export default {
  docTitle: "Authing 开发者中心",
  banner: {
    title: "开发者中心",
    subtitle: "使用 Authing 五分钟实现单点登录和完整的认证、授权",
  },
  nav: {
    sso: "单点登录",
    use: "使用 Authing",
    sdk: "SDK 接入",
    authorize: "授权",
    security: "安全",
    thirdLogin: "第三方登录",
    formLogin: "登录表单",
    scanLogin: "扫码登录",
    integrated: "系统集成",
    practice: "优秀实践",
    other: "其他",
  },
  status: {
    currentStatus: "当前状态",
    unLogin: "未登录",
    login: "你好，你已经处于登录状态",
    web: "Web 端登录",
    app: "微信移动端网页登录",
    session: "以下是你的会话信息",
    sessionTitle: "用户信息",
  },
  use: {
    title: "使用 Authing",
    "item-one": {
      title: "注册 Authing",
      subtitle:
        "探索如何创建一个 Authing 开发者账号，并熟悉一下 Authing 系统总体运行模式。",
      "list-one": "· Authing 用户池",
      "list-two": "· Authing 控制台",
      "list-three": "· 用户池信息",
    },
    "item-two": {
      title: "快速开始",
      subtitle: "使用 Authing 与 Guard 实现 SSO 的示例。",
      "list-one": "· 前往 SDK 仓库",
    },
    "item-three": {
      title: "开发文档",
      subtitle: "学习如何使用 Authing 进行开发，并理解身份认证的专业知识。",
      "list-one": "· Authing 是做什么的？",
      "list-two": "· 我们能帮助你做什么？",
      "list-three": "· 我们用到的专业术语",
    },
  },
  sdk: {
    title: "SDK 接入",
    subtitle:
      "提供多语言的 SDK 为用户封装 API 签名计算，组织请求结构，构建连接池提升请求效率和性能，解析返回结果等。",
    item0: {
      title: "小程序 SDK",
    },
  },
  authorize: {
    title: "授权",
    "item-one": {
      title: "配置用户权限",
      subtitle: "Authing 控制台中支持快速配置用户权限，操作流程。",
    },
    "item-two": {
      title: "在代码中读取/修改用户权限",
      subtitle: "Authing 权限控制。",
    },
  },
  security: {
    title: "安全",
    "item-one": {
      title: "配置 MFA 安全口令",
      subtitle: "多因素身份验证（MFA）是一种安全系统。",
    },
    "item-two": {
      title: "配置 Web 安全域",
      subtitle: "如何配置 Web 安全域。",
    },
    "item-three": {
      title: "配置密码强度",
      subtitle: "你可以在安全 -> 用户密码与数据加密 页面中可配置密码强度。",
    },
    "item-four": {
      title: "配置密码加密函数",
      subtitle: "自定义用户池中用户密码的加密方式。",
    },
  },
  thirdLogin: {
    title: "第三方登录",
    item0: {
      title: "接入社会化登录",
      subtitle: "Authing 社会化登录支持两种模式：托管模式和手动模式。",
    },
    item1: {
      title: "接入微信手机网页授权登录",
      subtitle: "微信手机网页授权登录。",
    },
    item2: {
      title: "使用 OIDC",
      subtitle:
        "OIDC 是 OAuth 2.0 的一个扩展，主要增加了语义化的用户信息字段。",
    },
    item3: {
      title: "使用 OAuth 2.0",
      subtitle: "使用 OAuth 2.0 将 Authing 用户池作为身份服务提供商。",
    },
    item4: {
      title: "使用 SAML",
      subtitle: "SAML 2.0 可以实现基于网络跨域的单点登录（SSO）。",
    },
    item5: {
      title: "配置第三方 LDAP 服务",
      subtitle: "LDAP 是一个树型的用来存储用户和组织信息的数据库。",
    },
    item6: {
      title: "使用 Authing 的 LDAP 用户目录",
      subtitle: "Authing 支持使用 LDAP 协议查看、修改、增加和删除用户信息。",
    },
  },
  formLogin: {
    title: "表单登录",
    "item-one": {
      title: "Guard 登录表单",
      subtitle: "Guard 是登录表单，用户可以使用选定的连接轻松进行身份验证。",
    },
    "item-two": {
      title: "Guard VS 自定义 UI",
      subtitle:
        "当将 Authing 接入你的应用程序时，可以使用 Authin 进行高级配置。",
    },
  },
  scanLogin: {
    title: "扫码登录",
    "item-one": {
      title: "接入小程序扫码登录",
      subtitle:
        "扫描小程序二维码并使用小程序「小登录」进行认证，使用「小登录」将提高 80% 的注册转化率并节省 100% 的短信成本。",
    },
    "item-two": {
      title: "接入私有化小程序",
      subtitle: "如果你是私有部署「小登录」的用户请查看本章节进行接入。",
    },
  },
  integrated: {
    title: "系统集成",
    "item-one": {
      title: "Confluence 接入 Authing OIDC 指南",
      subtitle: "详细介绍 Confluence 如何接入 Authing OIDC。",
    },
    "item-two": {
      title: "Spring Security 5 集成 Authing OIDC 单点登录指南",
      subtitle: "详细介绍 Spring Security 5 如何接入 Authing OIDC。",
    },
  },
  practice: {
    title: "优秀实践",
    "item-one": {
      title: "Express 集成 OIDC 单点登录指南",
      subtitle: "详细介绍 Express 如何集成 Authing OIDC 单点登录。",
    },
  },
  other: {
    title: "其他",
    "item-one": {
      title: "在单窗口中打开登录页面的代码示例",
      subtitle: "可查看代码示例。",
    },
    "item-two": {
      title: "错误代码",
      subtitle: "错误代码消息格式。",
    },
    "item-three": {
      title: "了解 Authing 自带的免费邮件和短信",
      subtitle:
        "邮件是 Authing 提供的针对使用「邮箱」注册的用户的邮件发送服务。",
    },
  },
  button: {
    doc: "单点登录文档",
    experience: "点击体验",
    logout: "退出登录",
    quickLogin: "快速登录",
    "learn-more": "查看详情",
  },
  wxLogin: "微信移动端网页登录",
};
